import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getLatestStepVersion} from 'pipelines/StepConnectionUtils';

import {ParseClipboardContentFn} from './CopyPasteTypes';
import {parseApiIdsClipboardContent} from './parseApiIdsClipboardContent';

// Named for the config key on IMPORT_PLATES, which predates the step also accepting inventory
// plate IDs. The key is persisted on saved steps, so it keeps its original name.
const PLATE_IDS_CONFIG_KEY = 'scratchPlateIds';

const IMPORTABLE_PLATE_TYPES = [ModelTypeConstants.SCRATCH_PLATE, ModelTypeConstants.PLATE] as const;

/** @package */
export const parsePlateIdsClipboardContent: ParseClipboardContentFn = (_pipelineId, text) => {
  if (!BenchlingConfig.PIPELINES_ENABLE_EXPERIMENTAL_SCRATCH_PLATE_STEPS) {
    return Promise.resolve(null);
  }
  const plateIds = parseApiIdsClipboardContent(text, IMPORTABLE_PLATE_TYPES);
  if (plateIds == null) {
    return Promise.resolve(null);
  }
  return Promise.resolve([
    {
      stepType: PipelineStepType.IMPORT_PLATES,
      stepVersion: getLatestStepVersion(PipelineStepType.IMPORT_PLATES),
      config: {[PLATE_IDS_CONFIG_KEY]: plateIds},
      incomingEdges: [],
      runAfterCreate: true,
    },
  ]);
};
